import React from "react"
import MyAppBar from "./app-bar"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import mercadolibre from "../images/site/temp/mercadolibre.svg"
import tiendanube from "../images/site/temp/deep-blue.svg"
const InfoStyle = styled.div`
  width: calc(100%);
  margin-top: 4px;
  margin-bottom: 8px;
  opacity: 0.8;
  font-size: 12px;
  text-align: left;
  padding-left: 48px;
  background-color: #f0f0f0;
  padding-bottom: 4px;
  border-bottom: #eaeaea solid 1px;
`
const Info = _ => (
  <InfoStyle>
    <b>☎ +54 11 4454-8343</b> | Blanco Encalada 1190 Villa Madero |
    ventas@fiammengo.com.ar&nbsp;
    <Link
      to="https://tienda.fiammengo.com.ar"
      activeClassName="perfil"
      className="perfil"
    >
      |{" "}
      <img
        alt="Tiendanube"
        style={{ height: "16px", padding: "4px 4px 0 4px" }}
        src={tiendanube}
      ></img>
      <b>Nuestro showroom&nbsp;</b>
    </Link>
    <Link
      to="https://shop.fiammengo.com.ar"
      activeClassName="perfil"
      className="perfil"
    >
      |{" "}
      <img
        alt="Mercado Libre"
        style={{ height: "16px", padding: "4px 4px 0 4px" }}
        src={mercadolibre}
      ></img>
      <b>En Mercado Libre</b>
    </Link>
  </InfoStyle>
)
const Header = _ => (
  <div>
    <MyAppBar />
    <Info />
  </div>
)
export default Header
